export default __webpack_public_path__ + "static/media/buy.5cb49ebd.svg";